import React, { useEffect, useState } from "react";
import "./Home.css";
import Banner from "../../components/banner/Banner";
import Title from "../../components/titles/Title";
import MainService from "../../common/MainService";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ManufacturerBenefits from "../../components/ManufacturerBenefits/ManufacturerBenefits";
import CategoryProducts from "../../components/CategoryProducts/CategoryProducts";
import DSN from "../../assets/images/technology-icons/dsn.svg";
import PPN from "../../assets/images/technology-icons/ppn.svg"
import MP from "../../assets/images/technology-icons/marketplace.svg"

// Main page for manufacturers
export default function Home() {
  const accessToken = () => {
    MainService.getAccess()
      .then((res) => {})
      .catch((err) => {
        console.log("Error", err);
      });
  };

  useEffect(() => {
    accessToken();
  }, []);

  const [getCatId] = useState("AGR11-100A");
 

  localStorage.setItem("catID", getCatId);
  useEffect(() => {
    if (!getCatId || getCatId === "") return;

  }, [getCatId]);


  return (
    <div>
      <Banner
        className="home-bg"
        bannerTitle={[
          <span key="1">Source Organic, Natural & Traceable Honey through </span>,
          <br key="2" className="d-lg-block d-none"></br>,
          <span key="3">Honey Contract Farming Services</span>
        ]}
      />

      <CategoryProducts
        btn1text="RFQ"
        categoryId={["AGR14-100A"]}
        title="Contract Farming Services"
        description="Services not found"
        subcategory="true"
      />

  
      <div className="section-container benefit-container">
        <div className="container">
          <div className="section-sub-container">
            <Title classname="text-center mb-4" heading="Benefits" />
          </div>
          <ManufacturerBenefits />
        </div>
      </div>
   

   
      <div className="section-container benefit-container">
        <div className="container">
        <div className="section-sub-container text-center">
            <Title heading="Our Technology" />
            <img className="technoloy-icons d-block mb-2 mx-auto mt-4" src={DSN} alt="Dark Store Network"/>
            <h5 className="mb-3">Dark Store Network (DSN)</h5>

            <p>Dark Store Network (DSN) is an innovative technology solution provided by Apischain to enable brands to efficiently store and manage their products in strategically located stores. Unlike traditional retail spaces, dark stores are dedicated facilities optimized for order fulfillment rather than customer browsing. DSN offers brands a seamless way to store products in these stores, allowing for faster delivery and more efficient inventory management. Through real-time tracking, inventory optimization, and advanced data insights, DSN helps brands reduce operational costs, improve supply chain efficiency, and enhance the overall customer experience with faster and more reliable order fulfillment.</p>
            <p>Agent, Agriminer, Store Owner, Store Operator, Store QA, Driver</p>
            <img className="technoloy-icons d-block mb-2 mx-auto mt-4" src={PPN} alt="Plant Production Network"/>
            <h5 className="mb-3">The Plant Production Network (PPN)</h5>

            <p>The Plant Production Network (PPN) is a technology platform developed by Apischain to support manufacturers in optimizing their plant production processes. By leveraging advanced digital solutions, PPN enhances efficiency, enables real-time data tracking, and improves overall production management. This network helps manufacturers streamline their operations, reduce costs, and ensure higher productivity by providing seamless integration between different stages of production and supply chains.</p>
            <p>Agent, AgriMiner, Plant Owner, Plant Operator, Plant QA, Plant Manager, Plant Technician, Worker, Plant Executive, Processing Worker, Packaging Worker </p>
            <img className="technoloy-icons d-block mb-2 mx-auto mt-4" src={MP} alt="Market-Place"/>
            <h5 className="mb-3">Marketplace</h5>

            <p>Marketplace is a technology platform developed by Apischain that facilitates the buying and selling of products. It connects buyers and sellers in a seamless digital environment, enabling efficient transactions and access to a wide range of goods</p>

          </div>
        </div>
      </div>
    </div>
  );
}
